import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, update, onValue, get, child, push } from "firebase/database";

const environment = process.env.REACT_APP_ENV? process.env.REACT_APP_ENV.toUpperCase(): 'TEST';
const firebaseConfig = {
    apiKey: process.env['REACT_APP_' + environment + '_CHAT_API_KEY'],
    authDomain: `${process.env['REACT_APP_' + environment + '_CHAT_PROJECT_ID']}.firebaseapp.com`,
    databaseURL: process.env['REACT_APP_' + environment + '_CHAT_DATABASE_URL'],
    projectId: process.env['REACT_APP_' + environment + '_CHAT_PROJECT_ID'],
    storageBucket: `${process.env['REACT_APP_' + environment + '_CHAT_PROJECT_ID']}.appspot.com`,
    messagingSenderId: process.env['REACT_APP_' + environment + '_CHAT_SENDER_ID'],
    appId: process.env['REACT_APP_' + environment + '_CHAT_APP_ID'],
    measurementId: process.env['REACT_APP_' + environment + '_CHAT_MEASUREMENT_ID'],
};
const chatInit = initializeApp(firebaseConfig)

export const chatDatabase = getDatabase(chatInit)

const date = new Date(Date.now());
const nowTime = date.getDate()+
    "/"+(date.getMonth()+1)+
    "/"+date.getFullYear()+
    " "+date.getHours()+
    ":"+date.getMinutes()+
    ":"+date.getSeconds()

export const setUserActiveOnChat = (userId) => {
    const status = {
        status: true,
    }
    update(ref(chatDatabase, `Users/${userId}`), status)
}

export const setUserDeActiveOnChat = (userId) => {
    const status = {
        status: false,
    }
    update(ref(chatDatabase, `Users/${userId}`), status)
}

export const createnewMessageUser = (userId) => {
    const userdata = {
        status: false,
        timestemp: nowTime
    }
    set(ref(chatDatabase, `Users/${userId}`), userdata)
}

export const createChatRoom = (customerId, supplierId, data) => {
    onValue(ref(chatDatabase, `chatRooms/${customerId}-${supplierId}`), (snapshot) => {
        if (snapshot.val() && (snapshot.val().mBuyerName || snapshot.val().mSupplierName)) {
        }else{
                set(ref(chatDatabase, `chatRooms/${customerId}-${supplierId}`), data)
                createSelectedRoomNewMessage(`${customerId}-${supplierId}`, "Say Hello", data.mBuyerName, customerId)
        }
    }, {
        onlyOnce: true
    })
}

const endsAt = (objectkey, userId, customerOrsupplier) => {
    const keyarray = objectkey.split('-')
    if (parseInt(keyarray[customerOrsupplier]) === userId) {
        return true
    }else{
        return false
    }
}



export const getCurrentUserChatrooms = async (userId, customerOrsupplier) => {
    const dbref = ref(chatDatabase)
    const rooms = await get(child(dbref, 'chatRooms')).then((snapshot) =>{
        if (snapshot.exists()) {
            const keys = Object.keys(snapshot.val())
            const valus = Object.values(snapshot.val())
            let chatroom = []
            for (let index = 0; index < keys.length; index++) {
                if (endsAt(keys[index], userId, customerOrsupplier)) {
                    const customer = keys[index].split("-")[0]
                    const supplier = keys[index].split("-")[1]
                    chatroom.push({
                        customer: parseInt(customer),
                        supplier: parseInt(supplier),
                        chatroomInfo: valus[index]
                    })
                }
                if (keys.length -1 === index) {
                    return chatroom
                }
            }
        } else {
        }
    }).catch((error) => {
        console.error(error);
    });
    return rooms
}



export const createSelectedRoomNewMessage = (link, messegetext, username, userid) => {
    const newPostKey = push(child(ref(chatDatabase), `${link}/`)).key;
    const messagedata = {
        mUserName: username,
        mUserId: userid,
        mTimestamp: nowTime,
        mText: messegetext,
        mIsRead: false
    }
    set(ref(chatDatabase, `chatRooms/${link}/messages/${newPostKey}`), messagedata)

}